import React, { useState, useEffect } from 'react';
import mixpanel from 'mixpanel-browser';
import { useDispatch, useSelector } from 'react-redux';

import { Home as HomeIcon } from '@mui/icons-material';

import { ModalButtonContent } from '../ModalButtonContent';

import { ModalPopup } from '../../Elements/Modal';
import { ResidencyModalContent } from './ResidencyModalContent';

import {
  getUserResidencyInfo,
  createUserResidencyInfo,
  patchUserResidencyInfo,
} from '../../../actions';

import { RESIDENCY_TITLE, STATE, ZIP_CODE } from '../../../constants/Dashboard/Residency';

import './Residency.css';

export const Residency = ({ setZipCode, setUsState, user, tokenValue }) => {
  const dispatch = useDispatch();
  const residencyInfoState = useSelector(({ residencyReducer }) => residencyReducer);
  const { userAddressId } = residencyInfoState;

  const [open, setOpen] = useState(false);
  const [isConfirmed, setIsConfirmed] = useState(!!userAddressId); // Check for all eventually

  useEffect(() => {
    dispatch(getUserResidencyInfo({ id: user.id, tokenValue }));
    setIsConfirmed(!!userAddressId);
  }, [userAddressId]);

  useEffect(() => {
    if (isConfirmed) {
      setZipCode(residencyInfoState['Zip Code']);
    }
  }, [isConfirmed]);

  const handleOpen = () => {
    setOpen(true);
    mixpanel.track('Dashboard Modal', {
      user_id: user.id,
      distinct_id: user.id,
      Modal: 'Residency',
      action: 'Open',
      confirmed: isConfirmed,
    });
  };
  const handleClose = () => {
    setOpen(false);
    mixpanel.track('Dashboard Modal', {
      user_id: user.id,
      distinct_id: user.id,
      Modal: 'Residency',
      action: 'Close',
      confirmed: isConfirmed,
    });
  };

  const handleConfirm = ({ residencyInfo }) => {
    setZipCode(residencyInfo[ZIP_CODE]);
    setUsState(residencyInfo[STATE]);

    mixpanel.track('Dashboard Modal', {
      user_id: user?.id,
      Modal: 'Residency',
      action: 'Confirm',
    });

    setIsConfirmed(true);
    if (residencyInfoState.userAddressId) {
      dispatch(
        patchUserResidencyInfo({
          id: residencyInfoState.userAddressId,
          body: residencyInfo,
          user,
          tokenValue,
        }),
      );
    } else {
      dispatch(
        createUserResidencyInfo({
          body: residencyInfo,
          user,
          tokenValue,
        }),
      );
    }

    setOpen(false);
  };

  return (
    <div className="dashboard-user-info-row-item">
      <ModalPopup
        buttonContent={
          <ModalButtonContent
            isConfirmed={isConfirmed}
            modalButtonIcon={<HomeIcon sx={{ mr: 2 }} />}
            modalButtonTitle={RESIDENCY_TITLE}
          />
        }
        modalContent={
          <ResidencyModalContent
            handleClose={handleClose}
            onConfirm={handleConfirm}
            residencyInfo={residencyInfoState}
            user={user}
          />
        }
        title={RESIDENCY_TITLE}
        modalButtonId="residency-modal-button"
        handleOpen={handleOpen}
        handleClose={handleClose}
        open={open}
      />
    </div>
  );
};
